// METIS Hub wording — namespace "app" (ko): product wording that the mockup does not have (hand-written).
// Mostly the real sign-in contract (first-admin setup code, server errors) and mockup texts that named the sample
// domain (example.com). Same rules as the extracted namespaces: ko/en pairs, "~해요/~하세요", plan 9.1.3 wording rules.
const app: Record<string, string> = {
  "notif.grant_dormant.title": "90일 동안 쓰지 않은 권한이 있어요",
  "notif.grant_dormant.body": "권한 재검토에서 계속 필요한지 확인하고 유지하거나 회수하세요.",
  "notif.grant_expiry_deferred.title": "마지막 관리자의 만료를 미뤘어요",
  "notif.grant_expiry_deferred.body": "다른 관리자에게 권한을 부여한 뒤 기존 관리자 권한의 재승인을 진행하세요.",

  "audit.detail.role_names": "{roles} · {teams}",
  "audit.detail.policy_change": "{path} · {from} → {to}",
  "event.user_prompt": "질문 입력",
  "event.answer": "AI 답변",
  "event.assistant_response": "AI 답변",
  "event.api_request": "AI 요청",
  "event.api_error": "AI 요청 오류",
  "event.api_retries_exhausted": "요청 재시도 끝남",
  "event.api_refusal": "AI 요청 거절",
  "event.tool_decision": "도구 실행 판단",
  "event.tool_result": "도구 실행 결과",
  "event.content_view": "글 열람",
  "event.permission_mode_changed": "허가 방식 변경",
  "event.subagent_completed": "하위 작업 완료",
  "event.skill_activated": "스킬 사용",
  "event.compaction": "대화 압축",
  "event.auth": "인증",
  "event.internal_error": "내부 오류",
  "event.mcp_server_connection": "도구 서버 연결",
  "event.plugin_installed": "플러그인 설치",
  "event.plugin_loaded": "플러그인 불러옴",
  "event.hook_execution_start": "연결 작업 시작",
  "event.hook_execution_complete": "연결 작업 완료",
  "event.managed_settings_resolved": "관리 설정 적용",
  "event.hook_registered": "연결 작업 등록",
  "event.conversation_starts": "대화 시작",
  "event.agent_response": "AI 답변",
  "event.websocket_request": "연결 요청",
  "event.websocket_connect": "실시간 연결",
  "event.sse_event": "응답 수신",
  "event.websocket_event": "응답 수신",
  "event.sandbox_outcome": "실행 환경 결과",
  "event.turn_cost": "이번 작업 비용",
  "event.turn_ttft": "첫 응답 대기",
  "event.startup_phase": "도구 시작 단계",
  "event.auth_recovery": "인증 복구",
  "event.plugin_install": "플러그인 설치",
  "event.guardian": "실행 보호 확인",
  "event.other": "기타 기록",
  "audit.detail.retention_window": "{setting} · {from}일 → {to}일",
  "people.export.pseudonyms": "사람은 가명으로 표시하고, 실명과 질문·답변 글은 넣지 않아요.",
  "admin.policy.envLocks": "설정 {n}개는 서버 환경 설정으로 고정되어 있어요",
  "admin.preview.otherRoles": "다른 역할도 가진 사람 수",
  "me.adv.workRiskTitle": "작업 상세를 기록할까요?",
  "me.adv.workRiskBody": "명령과 도구 입력에 비밀번호나 비밀 키가 들어갈 수 있어요. 저장 전에 가리지만 모든 비밀값을 알아내지는 못해요.",
  "me.adv.workRiskCheck": "이 위험을 이해했고 작업 상세 기록에 동의해요.",
  "admin.price.confirmedAt": "가격 확인일",
  "me.ds.tzDefault": "회사 시간대 사용",
  // 통계(SCR-05) — 계약(packages/contracts)에만 있는 값의 이름, 저장한 보기 링크 나누기, 실패 알림
  "stats.m.retries": "재시도",
  "stats.person.pseudonym": "사용자 #{code}",
  "stats.effort.max": "최대",
  "stats.decision.abort": "응답 없이 닫음",
  "stats.decision.timed_out": "시간 초과",
  "stats.errorKind.auth": "인증 오류",
  "stats.errorKind.client_error": "요청 오류(4xx)",
  "stats.errorKind.network": "네트워크 오류",
  "stats.errorKind.timeout": "시간 초과",
  "stats.errorKind.interrupted": "중간에 멈춤",
  "stats.errorKind.policy_rejected": "정책에 막힘",
  "stats.views.link": "링크로 나누기",
  "stats.views.linkDesc": "링크를 받은 사람도 열 수 있어요. 그 사람의 권한·보기 범위로 다시 판단해요.",
  "stats.views.linkOn": "링크로 나눔",
  "stats.views.copyLink": "링크 복사",
  "stats.views.edit": "고치기",
  "stats.views.editTitle": "저장한 보기를 고칠까요?",
  "stats.views.updated": "‘{name}’ 보기를 고쳤어요",
  "stats.views.fail": "저장한 보기를 바꾸지 못했어요. 다시 시도하세요.",
  "stats.views.loadFail": "저장한 보기 목록을 불러오지 못했어요.",
  "stats.export.fail": "내보내지 못했어요. 다시 시도하세요.",
  "stats.export.rowLimit": "행이 너무 많아 내보낼 수 없어요. 기간이나 조건을 좁혀 주세요.",
  "stats.export.previewNote": "미리보기는 이 카드의 표로 만들었어요. 받는 파일은 서버가 만들어 바로 보내요.",
  // 수집 상태(SCR-14) — 계약의 이유 코드(버린 이유·거절 이유·공백 이유·연결 문제)와 작업·진단
  "admin.sys.c1.refused": "받기 전에 거절",
  "admin.sys.drop.no_consent": "동의 전",
  "admin.sys.drop.before_consent": "동의 전에 보낸 기록",
  "admin.sys.drop.notice_outdated": "안내문 재동의 필요",
  "admin.sys.drop.withdrawn": "동의 철회",
  "admin.sys.drop.paused": "일시 중지",
  "admin.sys.drop.inside_pause_window": "일시 중지 구간에 보냄",
  "admin.sys.drop.store_off": "저장 꺼짐",
  "admin.sys.drop.ingest_disabled": "회사 수집 꺼짐",
  "admin.sys.drop.undeterminable_time": "시각 불명·미래 시각",
  "admin.sys.drop.older_than_retention": "보관 기간보다 오래됨",
  "admin.sys.drop.parse_error": "형식 오류",
  "admin.sys.drop.no_session": "대화 번호 없음",
  "admin.sys.drop.unknown_event": "모르는 기록(이름·건수만)",
  "admin.sys.drop.excluded_by_policy": "정책상 저장 안 함",
  "admin.sys.drop.noise": "건수만 세는 기록",
  "admin.sys.drop.level_off": "기록 수준 밖",
  "admin.sys.rej.no_token": "연결 토큰 없음",
  "admin.sys.rej.bad_token": "맞지 않는 연결 토큰",
  "admin.sys.rej.revoked": "폐기한 연결 토큰",
  "admin.sys.rej.expired": "만료된 연결 토큰",
  "admin.sys.rej.legacy_header": "옛 PoC 설정",
  "admin.sys.rej.browser_origin": "브라우저에서 보냄",
  "admin.sys.rej.rate_limited": "너무 자주 보냄",
  "admin.sys.rej.busy": "서버가 바쁨",
  "admin.sys.rej.too_large": "너무 큼",
  "admin.sys.rej.bad_format": "형식 오류",
  "admin.sys.gapReason.server_unreachable": "서버에 닿지 못함",
  "admin.sys.gapReason.no_receipt": "받은 것 없음(이유 알 수 없음)",
  "admin.sys.gapReason.helper_silent": "PC 도우미 응답 없음",
  "admin.sys.gapReason.restore": "복구 중",
  "admin.sys.gapReason.maintenance": "점검 중",
  "admin.sys.issue.no_records": "기록이 오지 않아요",
  "admin.sys.issue.helper_not_responding": "PC 도우미가 응답하지 않아요",
  "admin.sys.issue.helper_backlog": "PC 도우미에 못 보낸 기록이 쌓였어요",
  "admin.sys.issue.collect_token_expired": "연결 토큰이 만료됐어요",
  "admin.sys.issue.collect_token_revoked": "연결 토큰을 폐기했어요",
  "admin.sys.issue.legacy_settings": "옛 PoC 설정이 남아 있어요",
  "admin.sys.issue.sends_more_than_consent": "설정이 동의보다 많이 보내요",
  "admin.sys.issue.version_old": "지원 버전보다 낮아요",
  "admin.sys.issue.version_checking": "새 버전을 확인하고 있어요",
  "admin.sys.c4.issue.late": "보고서가 늦어요",
  "admin.sys.c4.issue.auth": "Admin 키가 거절됐어요",
  "admin.sys.c4.issue.rate_limited": "요청 한도에 걸렸어요",
  "admin.sys.c4.issue.no_admin_key": "Admin 키 없음",
  "admin.sys.c4.notConnected": "아직 연결하지 않았어요",
  "admin.sys.c4.syncProgress": "조직 사용량 보고서를 동기화하는 중이에요({done}/{total})",
  "admin.sys.c4.syncFailed": "동기화하지 못했어요 · 오류 번호 {code}",
  "admin.sys.c3.offWhat": "API 게이트웨이를 아직 켜지 않았어요.",
  "admin.sys.c2.sumOn": "시범 기기 {n}대 중 {p}대에 오류가 있어요.",
  "admin.sys.job.running": "도는 중",
  "admin.sys.job.ok": "마침",
  "admin.sys.job.partial": "일부만 마침",
  "admin.sys.job.error": "오류",
  "admin.sys.job.skipped": "건너뜀",
  "admin.sys.job.schedule": "예약 실행",
  "admin.sys.job.manual": "직접 실행",
  "admin.sys.job.deleted": "{n}건 지움",
  "admin.hl.sumWarn": "실행 단위 {n}개를 확인해야 해요. 저장 공간은 {p}를 썼어요.",
  "admin.hl.beat": "마지막 신호 {rel}",
  "admin.hl.stopped": "멈춤",
  "admin.hl.diag": "설정 진단",
  "admin.hl.diagSet": "있음",
  "admin.hl.diagMissing": "없음",
  "admin.hl.diagNote": "값은 보이지 않고, 설정이 있는지만 보여요.",
  // 비용 정책(SCR-15) — 계약의 단가 칸(캐시 저장 5분·1시간, 장문)과 저장 실패
  "admin.kinds.basisCalls": "호출 {n}건",
  "admin.price.techLive": "단가표 · 가격 버전 · USD / 100만 토큰",
  "admin.price.col.cacheWrite5m": "캐시에 저장(5분)",
  "admin.price.col.cacheWrite1h": "캐시에 저장(1시간)",
  "admin.price.long": "장문: {n}토큰을 넘으면 입력 {in} · 출력 {out}",
  "admin.price.errSave": "가격 버전을 예약하지 못했어요. 다시 시도하세요.",
  // 로그인 — 서버 계약(계획 11.4)에만 있는 단계·오류
  "login.googleHintPlain": "회사 Google 계정만 쓸 수 있어요.",
  "login.gerr.domainPlain": "회사 도메인 계정이 아니라서 로그인할 수 없어요. 회사 Google 계정으로 다시 시도하세요.",
  "login.err.wrongPlain": "아이디 또는 비밀번호가 맞지 않아요.",
  "login.expired": "로그인이 끝났어요. 다시 로그인하세요.",
  "login.loggedOut": "로그아웃했어요.",
  "login.mfa.errWrong": "인증 번호가 맞지 않아요. 다시 입력하세요.",
  "login.gate.pw.current": "지금 비밀번호(임시 비밀번호)",
  "login.gate.pw.errCurrent": "지금 비밀번호가 맞지 않아요.",
  "login.gate.pw.errServer": "비밀번호를 바꾸지 못했어요. 조건을 확인하고 다시 시도하세요.",
  "login.setup.kicker": "처음 설치 · 최초 관리자",
  "login.setup.title": "최초 관리자를 만들어 주세요",
  "login.setup.desc": "아직 사용자가 없어요. 서버 데이터 폴더에 있는 일회용 설정 코드를 넣고 첫 관리자 계정을 만드세요.",
  "login.setup.code": "일회용 설정 코드",
  "login.setup.codeHint": "설치한 사람만 읽을 수 있는 파일에 있어요. 한 번 쓰면 다시 쓸 수 없어요.",
  "login.setup.displayName": "이름",
  "login.setup.email": "이메일",
  "login.setup.submit": "관리자 만들기",
  "login.setup.busy": "만드는 중…",
  "login.setup.done": "최초 관리자를 만들었어요. 방금 만든 계정으로 로그인하세요.",
  "login.setup.err.required": "모든 칸을 채워 주세요.",
  "login.setup.err.email": "이메일 주소 형식이 맞지 않아요.",
  "login.setup.err.code": "설정 코드가 맞지 않거나 이미 쓴 코드예요.",
  // 사람·팀(SCR-06)·사람 상세(SCR-07)·팀 상세 — 계약에만 있는 동작(계정 만들기, 팀 관리, 로그인 끊기, 되돌리기, 오류)
  "people.pseudonym": "사용자 #{code}",
  "people.save": "저장",
  "people.reasonOpt": "이유(선택)",
  "people.create.btn": "사람 만들기",
  "people.create.title": "사람 만들기",
  "people.create.kicker": "계정 만들기",
  "people.create.name": "이름",
  "people.create.method": "로그인 방법",
  "people.create.method.password": "아이디 · 임시 비밀번호",
  "people.create.method.google": "Google 계정만",
  "people.create.loginId": "아이디",
  "people.create.loginIdHint": "영문·숫자와 . _ - 를 써서 3~64자로 적어요.",
  "people.create.googleHint": "이 메일의 회사 Google 계정으로만 로그인해요. 비밀번호는 만들지 않아요.",
  "people.create.roleHint": "시작 역할은 내가 줄 수 있는 범위에서 골라요. 일반 사용자 역할은 계속 유지돼요.",
  "people.create.roleTeams": "역할을 적용할 팀",
  "people.create.approvalHint": "이 역할은 다른 담당자의 승인이 필요해요. 승인 전에는 일반 사용자로 시작해요.",
  "people.inv.roleNotApplied": "시작 역할 미적용 · {status}",
  "people.inv.approval": "승인 요청 {code}을 만들었어요. 초대를 수락해도 승인 전에는 일반 사용자 권한만 있어요.",
  "admin.apr.targetInvite": "초대 {email} · 시작 역할 {role}",
  "admin.apr.awaitingInvite": "승인됨 · 시작 역할 미적용",
  "people.create.approval": "승인 요청 {code}을 만들었어요. 승인 전에는 일반 사용자 권한만 있어요.",
  "people.create.make": "계정 만들기",
  "people.create.err.name": "이름을 적어 주세요.",
  "people.create.err.loginId": "아이디는 영문·숫자와 . _ - 로 3~64자예요.",
  "people.create.err.dup": "이미 있는 아이디나 메일이에요.",
  "people.create.done.title": "계정을 만들었어요",
  "people.create.done.lead": "{name}에게 아래 임시 비밀번호를 전해 주세요. 지금 한 번만 보여요.",
  "people.create.done.loginId": "아이디 {id}",
  "people.create.done.next": "첫 로그인 때 비밀번호를 바꾸고, 기록 수준을 고른 뒤 도구를 연결해요.",
  "people.create.done.google": "{name} 님은 {email} Google 계정으로 로그인해요. 첫 로그인 때 기록 수준을 고르고 도구를 연결해요.",
  "people.create.toast": "계정을 만들었어요. 사람 탭에서 볼 수 있어요.",
  "people.inv.emailHintPlain": "회사가 허용한 도메인의 메일만 초대할 수 있어요.",
  "people.inv.err.domainPlain": "허용한 도메인의 메일이 아니에요. 회사 메일로 초대하세요.",
  "people.inv.resent.title": "새 초대 코드를 만들었어요",
  "people.bulk.skipped": "{n}명은 건너뛰었어요.",
  "people.role.approvals": "승인 요청 {codes}",
  "people.role.loadErr": "줄 수 있는 역할을 불러오지 못했어요.",
  "people.role.noRoles": "내 권한 안에서 줄 수 있는 역할이 없어요.",
  "people.role.previewLoading": "어떻게 적용되는지 확인하는 중이에요",
  "people.role.teamsDefault": "매니저·위임 관리자 역할은 각 사람의 지금 팀에 적용돼요.",
  "people.undo.sub": "{s}초 안에 되돌릴 수 있어요",
  "people.undo.done": "되돌렸어요. 바꾸기 전으로 돌아갔어요.",
  "people.undo.expired": "되돌릴 수 있는 시간이 지났어요.",
  "people.err.failed": "바꾸지 못했어요. 잠시 뒤 다시 시도하세요.",
  "people.err.code": "(오류 번호 {code})",
  "people.err.forbidden": "지금 역할로는 할 수 없어요.",
  "people.err.notFound": "대상을 찾을 수 없어요. 이미 바뀌었을 수 있어요.",
  "people.err.conflict": "다른 변경과 겹쳤어요. 새로 고친 뒤 다시 해 보세요.",
  "people.err.invalid": "입력한 값을 확인해 주세요.",
  "people.err.approvalPending": "이미 승인을 기다리는 요청이 있어요. 관리 → 역할·권한 → 승인 대기에서 처리하세요.",
  "people.err.teamsRequired": "적용할 팀을 골라 주세요.",
  "people.err.nameDup": "같은 이름이 이미 있어요.",
  "people.err.rate": "요청이 너무 많아요. 잠시 뒤 다시 시도하세요.",
  "people.err.mfa": "역할을 다루려면 다단계 인증(MFA)이 필요해요. 내 기록·동의 → 내 정보·알림·화면 → [MFA 등록]을 마친 뒤 다시 시도하세요.",
  "people.err.pledge": "역할을 다루려면 금지 용도 약정을 먼저 마쳐야 해요. 화면을 새로 고쳐 약정을 마친 뒤 다시 시도하세요.",
  "people.d.authNoteTok": "사용량(토큰) 기준 · Claude는 기기마다 마지막으로 확인한 방식이에요",
  "people.d.sessions.btn": "로그인 끊기",
  "people.d.sessions.title": "이 사람의 로그인을 모두 끊을까요?",
  "people.d.sessions.body": "열려 있는 모든 브라우저에서 바로 로그아웃돼요. 다시 로그인하면 쓸 수 있고, 연결한 도구는 그대로예요.",
  "people.d.sessions.apply": "로그인 끊기",
  "people.d.sessions.done": "로그인 {n}개를 끊었어요.",
  "people.d.reset.btn": "임시 비밀번호",
  "people.d.reset.title": "임시 비밀번호를 새로 줄까요?",
  "people.d.reset.body": "지금 비밀번호는 바로 쓸 수 없게 되고, 다음 로그인 때 비밀번호를 바꿔야 해요. 새 임시 비밀번호는 한 번만 보여요.",
  "people.d.reset.apply": "새로 받기",
  "people.d.grant.revoke": "거두기",
  "people.d.grant.revokeTitle": "‘{role}’ 역할을 거둘까요?",
  "people.d.grant.revokeBody": "이 역할로 받은 권한이 바로 사라지고 대상자의 로그인이 다시 시작돼요. 10초 안에는 되돌릴 수 있어요.",
  "people.d.grant.done": "‘{role}’ 역할을 거뒀어요.",
  "people.d.grant.notFound": "거둘 역할 부여를 찾지 못했어요. 역할·권한 화면에서 거둬 주세요.",
  "people.issue.no_records": "받은 기록 없음",
  "people.issue.helper_not_responding": "PC 도우미가 응답하지 않아요",
  "people.issue.helper_backlog": "PC 도우미에 보낼 기록이 쌓여 있어요",
  "people.issue.collect_token_expired": "연결 토큰이 만료됐어요",
  "people.issue.collect_token_revoked": "연결 토큰을 폐기했어요",
  "people.issue.legacy_settings": "옛 PoC 설정이 남아 있어요",
  "people.issue.sends_more_than_consent": "동의한 것보다 많이 보내고 있어요",
  "people.issue.version_old": "CLI 버전이 오래됐어요",
  "people.issue.version_checking": "CLI 버전을 확인하는 중이에요",
  "people.svc.st.active": "사용 중",
  "people.svc.st.suspended": "정지됨",
  "people.svc.st.expired": "만료됨",
  "people.teams.hiddenTechPlain": "팀 고르기 · 소집단 보호",
  "people.export.btn": "팀 집계 내보내기",
  "people.export.title": "팀 집계 내보내기",
  "people.export.format": "파일 형식",
  "people.export.b1": "팀별 합계만 담아요. 사람 이름과 글은 들어가지 않아요.",
  "people.export.b2": "3명보다 적은 팀은 합쳐서 적고, 사람 수는 ‘<3’으로 적어요.",
  "people.export.b3": "내보낸 일은 열람·변경 이력에 남아요.",
  "people.export.apply": "내보내기",
  "people.export.done": "팀 집계를 내보냈어요.",
  "people.tree.q": "팀은 어떻게 나뉘어 있나요?",
  "people.tree.tech": "팀 구성 · 본부 › 팀 · 매니저",
  "people.tree.sum": "쓰는 팀 {n}개 · 본부 {g}개 · 보관한 팀 {a}개예요.",
  "people.tree.create": "팀 만들기",
  "people.tree.edit": "고치기",
  "people.tree.managers": "매니저 지정",
  "people.tree.archive": "보관",
  "people.tree.group": "본부",
  "people.tree.archived": "보관됨",
  "people.tree.members": "{n}명",
  "people.tree.mgr": "매니저 {names}",
  "people.tree.noMgr": "매니저 없음",
  "people.tree.empty": "아직 만든 팀이 없어요.",
  "people.tree.emptyNot": "팀을 만들면 팀별 사용량과 매니저 범위를 쓸 수 있어요.",
  "people.teamForm.loadErr": "팀 목록을 불러오지 못했어요. 창을 닫고 다시 시도해 주세요.",
  "people.teamForm.cycle": "자신이나 자신의 하위 팀 아래로 옮길 수 없어요.",
  "people.teamForm.depth": "팀을 너무 여러 단계로 나눌 수 없어요. 더 위의 팀을 골라 주세요.",
  "people.teamForm.parentMembers": "사람이 있는 팀 아래에는 하위 팀을 만들 수 없어요. 먼저 사람을 옮겨 주세요.",
  "people.teamForm.parentInvites": "이 팀의 대기 중인 초대를 먼저 취소해 주세요.",
  "people.archive.members": "남아 있는 사람을 먼저 다른 팀으로 옮겨 주세요.",
  "people.archive.children": "하위 팀을 먼저 옮기거나 보관해 주세요.",
  "people.teamForm.archived": "보관된 팀은 고칠 수 없어요.",
  "people.teamForm.groupMembers": "사람은 그룹이 아닌 팀에 속해야 해요.",
  "people.archive.b4": "아직 사용하지 않은 이 팀의 초대 코드와 대기 중인 시작 역할 승인도 취소돼요.",
  "people.tree.note": "팀을 보관하거나 옮겨도 지난 기록의 소속은 그대로예요(기록 당시 소속).",
  "people.teamForm.editTitle": "팀 고치기",
  "people.teamForm.name": "팀 이름",
  "people.teamForm.nameHint": "40자까지 적을 수 있어요.",
  "people.teamForm.parent": "위 단계(본부)",
  "people.teamForm.noParent": "없음(맨 위)",
  "people.teamForm.group": "본부로 만들기",
  "people.teamForm.groupDesc": "팀을 묶는 단위예요. 사람은 팀에 속해요.",
  "people.teamForm.groupOn": "본부에는 사람을 넣을 수 없어요. 사람을 넣으려면 이 본부 아래에 팀을 하나 더 만들어야 해요. 사람을 바로 넣을 팀이면 끄세요.",
  "people.teamForm.groupPeople": "사람이 있는 팀은 본부로 바꿀 수 없어요. 먼저 사람을 다른 팀으로 옮겨 주세요.",
  "people.teamForm.groupOffDesc": "끄면 일반 팀이 되어 사람을 넣을 수 있어요.",
  "people.teamForm.groupLocked": "아래에 팀이 있어 일반 팀으로 바꿀 수 없어요. 아래 팀을 먼저 옮기거나 보관해 주세요.",
  "people.tree.groupEmpty": "아래 팀 없음 · 사람을 넣으려면 [고치기]에서 일반 팀으로 바꾸거나 아래에 팀을 만드세요",
  "people.teamForm.err.name": "팀 이름을 적어 주세요.",
  "people.teamForm.err.dup": "같은 이름의 팀이 이미 있어요.",
  "people.teamForm.created": "‘{team}’ 팀을 만들었어요.",
  "people.teamForm.saved": "팀을 고쳤어요.",
  "people.archive.title": "‘{team}’{eul} 보관할까요?",
  "people.archive.b1": "팀 고르기와 팀 비교에서 빠지고, 새 사람을 넣을 수 없어요.",
  "people.archive.b2": "지난 기록의 소속은 그대로 남아요(기록 당시 소속).",
  "people.archive.b3": "남아 있는 사람은 먼저 다른 팀으로 옮겨 주세요.",
  "people.archive.apply": "보관",
  "people.archive.done": "‘{team}’ 팀을 보관했어요.",
  "people.del.title": "‘{team}’{eul} 지울까요?",
  "people.del.b1": "한 번도 쓰지 않은 팀만 지울 수 있어요(소속·기록·초대·권한 이력과 하위 팀이 없을 때).",
  "people.del.b2": "이력이 있는 팀은 지우지 말고 보관하세요. 보관해도 지난 기록의 소속은 그대로예요.",
  "people.del.b3": "지운 팀은 되돌릴 수 없어요. 지운 일은 열람·변경 이력에 남아요.",
  "people.del.apply": "삭제",
  "people.del.done": "‘{team}’ 팀을 지웠어요.",
  "people.del.inUse": "이 팀은 소속·기록·초대·권한 이력이 있어 지울 수 없어요. 대신 보관하세요.",
  "people.mgr.pending": "{code} 승인 대기 중이에요. 승인될 때까지 기존 매니저를 유지해요.",
  "people.mgr.expiry": "새로 지정할 매니저의 만료일 (선택)",
  "admin.apr.targetManagers": "‘{team}’ 매니저 변경",
  "admin.apr.managerChanges": "추가: {added} · 해제: {removed}. 승인 시 함께 반영하며 다른 팀의 지정은 유지해요.",
  "admin.grants.managerRefresh": "팀 명단을 다시 불러오거나 대기 중인 승인을 먼저 처리해 주세요.",
  "people.mgr.title": "매니저 지정",
  "people.mgr.pick": "매니저로 지정할 사람",
  "people.mgr.max": "10명까지 고를 수 있어요.",
  "people.mgr.none": "이 팀에 지금 있는 사람이 없어요.",
  "people.mgr.rule": "매니저 지정은 매니저 역할 부여와 맡을 팀 지정을 한 번에 해요. 매니저는 팀 집계와 팀원별 합계를 보고, 팀원의 질문·답변 글은 볼 수 없어요.",
  "people.mgr.apply": "지정하기",
  "people.mgr.done": "‘{team}’ 매니저를 바꿨어요. 대상자의 로그인이 다시 시작돼요.",
  "people.tp.kicker": "팀",
  "people.tp.q": "이 팀은 AI를 어떻게 쓰나요?",
  "people.tp.use.q": "이 팀은 얼마나 쓰나요?",
  "people.tp.use.tech": "팀 합계 · 기록 당시 소속 · 이름 없이",
  "people.tp.ratio": "CLI 도구 : API 키 호출",
  "people.tp.people.q": "이 팀에는 누가 있나요?",
  "people.tp.mgmt.q": "이 팀은 누가 맡고 있나요?",
  "people.tp.mgmt.tech": "매니저 · 위 단계 · 아래 팀",
  "people.tp.sub": "아래 팀",
  "people.tp.archived": "보관한 팀이에요. 지난 기록만 남아 있어요.",
  "people.tp.nf.title": "이 팀을 찾을 수 없어요",
  "people.tp.nf.desc": "없는 팀이거나 지금 역할로 볼 수 있는 범위 밖이에요. 필요하면 관리자에게 요청하세요.",
  // 로그인 — 첫 로그인 관문(계획 11.4.4: 비밀번호 → 금지 용도 약정 → 다단계 인증 등록 → 안내문 동의)
  "login.gate.loading": "처음 로그인 단계를 확인하는 중이에요",
  "login.gate.errLoad": "처음 로그인 단계를 불러오지 못했어요. 잠시 뒤 다시 시도하세요.",
  "login.gate.s.consent": "안내문 동의",
  "login.gate.consent.title": "기록 안내문을 읽고 동의해 주세요",
  "login.gate.consent.desc": "AI 사용 기록에 무엇이 남고 누가 볼 수 있는지 끝까지 읽고, 남길 수준을 골라 주세요. 기록 수준은 나중에 언제든 바꿀 수 있어요.",
  "login.gate.consent.level": "남길 수준",
  "login.gate.consent.levelHint": "처음에는 ① 기본 정보만 남겨요. 회사 상한보다 높은 단계는 고를 수 없어요.",
  "login.gate.consent.submit": "동의하고 시작하기",
  "login.gate.consent.done": "안내문에 동의했어요 · {level}까지 기록해요",
  "login.gate.consent.changed": "안내문이 방금 바뀌었어요. 새 안내문을 끝까지 읽고 다시 동의해 주세요.",
  "login.gate.consent.errServer": "동의를 저장하지 못했어요. 잠시 뒤 다시 시도하세요.",
  "login.gate.pledge.signPlain": "서명 — 계정 이름을 그대로 입력하세요",
  "login.gate.pledge.versionV": "약정문 {v} · 역할이 바뀌거나 약정문이 바뀌면 다시 약정해요 · 약정은 열람·변경 이력에 남아요",
  "login.gate.pledge.changed": "약정문이 방금 바뀌었어요. 새 약정문을 읽고 다시 약정해 주세요.",
  "login.gate.pledge.errServer": "약정을 남기지 못했어요. 잠시 뒤 다시 시도하세요.",
  "login.gate.mfaSetup.titlePlain": "다단계 인증(MFA) 등록",
  "login.gate.mfa.keyLabel": "설정 키",
  "login.gate.mfa.qrLabel": "MFA 등록용 QR코드",
  "login.gate.mfa.qrHint": "인증 앱에서 계정 추가 → QR코드 스캔을 선택해 이 코드를 읽어 주세요.",
  "login.gate.mfa.apps": "Google Authenticator, Microsoft Authenticator 등 일회용 인증 번호를 만드는 앱을 사용할 수 있어요.",
  "login.gate.mfa.manualHint": "QR코드를 읽을 수 없다면 아래 설정 키를 인증 앱에 직접 입력하세요.",
  "login.gate.mfa.keyHint": "이 키는 지금 한 번만 보여요.",
  "login.gate.mfa.openApp": "휴대폰이면 인증 앱에서 바로 열기",
  "login.gate.mfa.errEnroll": "설정 키를 받지 못했어요. 다시 시도하세요.",
  // 로그인 — 초대 코드로 계정 만들기(계획 8.4.1·7.1.4)
  "login.invite.link": "초대 코드로 계정 만들기",
  "login.invite.kicker": "초대 코드 · 계정 만들기",
  "login.invite.title": "초대받은 계정을 만들어요",
  "login.invite.desc": "관리자에게 받은 초대 코드를 넣으세요. 코드는 받은 날부터 7일 동안 쓸 수 있어요.",
  "login.invite.descOk": "초대를 확인했어요. 아이디·이름·비밀번호를 정하면 계정이 만들어져요.",
  "login.invite.code": "초대 코드",
  "login.invite.codeHint": "AIAX-로 시작하는 코드예요(예: AIAX-7KQ2-M4XA).",
  "login.invite.check": "초대 확인",
  "login.invite.checking": "확인하는 중…",
  "login.invite.invalid": "초대 코드가 맞지 않거나 기한이 지났어요. 관리자에게 새 코드를 받으세요.",
  "login.invite.okTitle": "확인된 초대예요",
  "login.invite.email": "메일",
  "login.invite.team": "팀",
  "login.invite.expires": "기한",
  "login.invite.until": "{at}까지",
  "login.invite.loginIdHint": "영문·숫자와 . _ - 로 3~64자",
  "login.invite.submit": "계정 만들기",
  "login.invite.busy": "만드는 중…",
  "login.invite.done": "계정을 만들었어요. 방금 만든 계정으로 로그인하세요.",
  "login.invite.otherCode": "다른 코드 넣기",
  "login.invite.back": "로그인으로 돌아가기",
  "login.invite.err.code": "초대 코드를 끝까지 넣어 주세요.",
  "login.invite.err.loginId": "아이디는 영문·숫자와 . _ - 로 3~64자여야 해요.",
  "login.invite.err.taken": "이미 쓰는 아이디예요. 다른 아이디를 고르세요.",
  "login.invite.err.server": "계정을 만들지 못했어요. 입력을 확인하고 다시 시도하세요.",
  // 내 기록·동의·설정(SCR-10) — 계약에만 있는 상태·오류
  "me.st.loadError": "지금 기록 상태를 불러오지 못했어요",
  "me.err.save": "저장하지 못했어요. 잠시 뒤 다시 시도하세요.",
  "me.err.prefs": "설정을 저장하지 못해 원래대로 돌렸어요",
  "me.lv.overCap": "회사 상한보다 높게 고를 수 없어요. 상한이 바뀌었을 수 있어요.",
  "me.n.changed": "안내문이 방금 바뀌었어요. 새 안내문을 끝까지 읽고 다시 동의해 주세요.",
  "me.w.undoExpired": "되돌릴 수 있는 시간이 지났어요. 다시 동의하면 기록을 다시 시작해요.",
  "me.c.busy": "만드는 중…",
  "me.c.fail": "사본을 만들지 못했어요. 잠시 뒤 다시 시도하세요.",
  "me.c.readyPlain": "사본이 준비됐어요",
  "me.d.noTitle": "제목 없음",
  "me.d.auto": "동의 철회로 자동",
  "me.d.st.canceled": "취소함 · 다시 보여요",
  "me.d.st.waiting": "처리 대기",
  "me.d.cancel": "요청 취소",
  "me.d.cancelTitle": "삭제 요청 {code}를 취소할까요?",
  "me.d.cancelLead": "취소하면 그 기록이 다시 목록·상세·합계에 보여요. 취소한 일은 열람·변경 이력에 남아요.",
  "me.d.canceled": "삭제 요청을 취소했어요 · 기록이 다시 보여요",
  "me.v.roleOnly": "열람자 이름 대신 역할을 보여 줘요(문의: 개인정보 보호책임자).",
  "me.v.more": "더 보기",
  "me.v.conv": "대화 #{no}",
  "me.a.loginGoogle": "Google 계정",
  "me.a.mfaEnroll": "MFA 등록",
  "me.a.mfaMissing": "등록 안 됨 · 꼭 필요해요",
  "me.a.mfaMissingD": "관리 권한이 있는 역할이라 인증 앱을 등록해야 해요.",
  "me.a.mfaOffD": "꼭 필요한 역할은 아니지만 직접 켤 수 있어요.",
  "me.a.pledgeDone": "{v} · {date} 확인함 · 역할이 바뀌면 다시 확인해요",
  "me.pw.open": "비밀번호 바꾸기",
  "me.pw.title": "비밀번호 바꾸기",
  "me.pw.lead": "바꾸면 지금 이 브라우저를 뺀 다른 곳의 로그인이 모두 끝나요.",
  "me.pw.current": "지금 비밀번호",
  "me.pw.done": "비밀번호를 바꿨어요",
  "me.pw.doneEnded": "비밀번호를 바꿨어요 · 다른 곳 로그인 {n}곳을 끝냈어요",
  "me.pw.locked": "여러 번 틀려서 잠시 잠갔어요. 잠시 뒤 다시 시도하세요.",
  "me.mfa.lead": "인증 앱에 METIS Hub 계정을 추가하고, 앱에 나온 6자리 번호로 등록을 완료하세요.",
  "me.s.unknown": "알 수 없는 기기",
  "me.s.rule": "{idle}분 동안 쓰지 않거나 {hours}시간이 지나면 다시 로그인해요.",
  "me.ds.tz": "시간대",
  "me.ds.tzSeoul": "한국 시간 · 조직 설정을 따라요",
  "me.ds.tzOther": "조직 시간대({tz})를 따라요",
  "me.ds.sampleNum": "숫자 예시",
  "me.ds.sampleText": "긴 글 예시",
  "me.ds.note": "화면 설정은 내 계정에 저장돼 다른 기기에서도 같아요. 언어·테마는 바로 바뀌고, 숫자·글자 크기·줄바꿈은 아래 미리보기로 확인해요.",
  "redact.credential": "인증 정보",
  "redact.account": "계좌 번호",
  "redact.blob": "긴 데이터 덩어리",
  // 열람·변경 이력(SCR-13) — 계약의 행위 코드(BUILD-SPEC-api §8)·세부 키·검사 결과
  "audit.pseudonym": "사용자 #{code}",
  "audit.actor.system": "시스템(자동)",
  "audit.personPicked": "고른 사람",
  "audit.where": "어디서",
  "audit.err.save": "남기지 못했어요. 잠시 뒤 다시 시도하세요.",
  "audit.err.verify": "검사하지 못했어요. 잠시 뒤 다시 시도하세요.",
  "audit.kpi.never": "검사 전",
  "audit.kpi.neverHint": "아직 검사한 기록이 없어요",
  "audit.integ.never": "아직 검사한 기록이 없어요. [지금 검사]로 사슬과 외부 고정점을 맞춰 보세요.",
  "audit.integ.autoAt": "마지막 자동 검사 {at}",
  "audit.integ.boxAnchor": "외부 고정점과 달라요 · {date} 고정점 뒤에 이력이 바뀌었을 수 있어요",
  "audit.integ.sumAnchor": "{n}건의 사슬은 이어지지만 외부 고정점 {date}과 맞지 않아요.",
  "audit.integ.firstBad": "처음 어긋난 행",
  "audit.anchor.file": "서명 파일",
  "audit.anchor.object_storage": "고칠 수 없는 저장소",
  "audit.anchor.email": "메일 보관",
  "audit.anchor.other": "외부 보관",
  "audit.bulkInCase": "조사 건 안의 열람이에요 · {from}~{to}",
  "audit.rep.month": "점검할 달",
  "audit.rep.counts": "{n}건(거부 {d})",
  "audit.rep.n": "{n}건",
  "audit.rep.reviewed": "이 달 점검 결과: {verdict} · {by} · {at}",
  "audit.csv.kicker": "내보낼 행 {n}개",
  "audit.csv.identityD": "실명 포함은 사유 범주와 사유(10자 이상)가 필요하고, 대상자마다 이력이 남아요.",
  "audit.csv.pickCat": "사유 범주 고르기",
  "audit.csv.needCat": "사유 범주를 골라 주세요.",
  "audit.csv.needReason": "사유를 {min}자 이상 써 주세요.",
  "audit.csv.reasonHint": "{min}자 이상 · 지금 {n}자",
  "audit.csv.rowLimit": "한 번에 내보낼 수 있는 행 수를 넘었어요. 기간이나 조건을 좁혀 주세요.",
  "audit.act.login.locked": "로그인 잠김",
  "audit.act.login.revoke": "다른 곳 로그아웃",
  "audit.act.logout": "로그아웃",
  "audit.act.reauth": "다시 로그인 확인",
  "audit.act.password.change": "비밀번호 바꿈",
  "audit.act.mfa.enroll": "다단계 인증 등록",
  "audit.act.pledge.ack": "금지 용도 약정",
  "audit.act.role.delete": "역할 지움",
  "audit.act.role.grant": "역할 줌",
  "audit.act.role.revoke": "역할 거둠",
  "audit.act.access.review": "권한 재검토",
  "audit.act.case.create": "조사 건 만들기",
  "audit.act.case.defer_notice": "통지 유예",
  "audit.act.person.create": "사용자 만들기",
  "audit.act.person.disable": "사용자 정지",
  "audit.act.person.enable": "사용자 복구",
  "audit.act.person.reset_password": "임시 비밀번호 발급",
  "audit.act.team.create": "팀 만들기",
  "audit.act.team.update": "팀 고침",
  "audit.act.team.archive": "팀 보관",
  "audit.act.team.delete": "팀 삭제",
  "audit.act.team.move": "팀 옮김",
  "audit.act.team.managers": "매니저 지정",
  "audit.act.invite.create": "초대",
  "audit.act.invite.resend": "초대 다시 보냄",
  "audit.act.invite.cancel": "초대 취소",
  "audit.act.invite.accept": "초대로 가입",
  "audit.act.sa.resume": "서비스 계정 다시 켬",
  "audit.act.apikey.create": "API 키 등록",
  "audit.act.apikey.update": "API 키 고침",
  "audit.act.credential.create": "회사 AI 키 등록",
  "audit.act.credential.rotate": "회사 AI 키 교체",
  "audit.act.credential.revoke": "회사 AI 키 폐기",
  "audit.act.token.issue": "연결 토큰 발급",
  "audit.act.glossary.add": "용어 추가",
  "audit.act.glossary.edit": "용어 고침",
  "audit.act.glossary.revert": "용어 되돌림",
  "audit.act.glossary.hide": "용어 숨김",
  "audit.act.glossary.unhide": "용어 다시 보임",
  "audit.act.glossary.linkcheck": "용어집 링크 점검",
  "audit.act.change.undo": "변경 되돌림",
  "audit.detail.reason_too_short": "사유가 짧아 막힘 · 최소 {min}자",
  "audit.detail.verify_ok": "{n}건 사슬 · 원래대로",
  "audit.detail.verify_bad": "{n}건 사슬 · #{seq}부터 어긋남",
  "audit.detail.verify_anchor": "{n}건 사슬 · 고정점과 다름",
  "audit.detail.anchor": "{date} 고정점과 맞춰 봄",
  "audit.detail.review": "{month} 월간 점검 · {verdict}",
  "audit.detail.export_rows": "{rows}행 · {format}",
  "audit.detail.export_identity": "실명 포함",
  "audit.detail.grant": "{role} 역할 줌",
  "audit.detail.revoke": "{role} 역할 거둠",
  "audit.detail.perm": "{role} · {perm} {sFrom} → {sTo}",
  "audit.detail.teams": "팀 {teams}",
  "audit.detail.until": "{date}까지",
  "audit.detail.undo": "되돌림",
  "audit.detail.code": "{code}",
  "audit.detail.level": "기록 수준 {levelFrom} → {levelTo}",
  "audit.detail.pause": "잠시 멈춤 · {until}까지",
  "audit.detail.resume": "기록 다시 시작",
  "audit.detail.withdraw": "동의 철회 · 전체 삭제 요청 함께 만듦",
  "audit.detail.withdraw_undo": "동의 철회 되돌림",
  "audit.detail.agree": "안내문 {notice}에 동의",
  "audit.detail.login_method": "{method}",
  "audit.detail.attempt": "{n}번째 시도",
  "audit.detail.sessions_ended": "다른 곳 로그인 {n}곳 끝냄",
  "audit.detail.notice": "안내문 {from} → {to} · 재동의 요청",
  // 셸
  "rail.problems": "오류로 연결 안 됨 {n}개",
  "bell.unread": "안 읽음",
  "app.loading": "계정 정보를 불러오는 중이에요",
  // 공용 부품
  "access.chars": "{n}자",
  // 도구 연결(SCR-08) — 서버 계약에만 있는 상태·기능(목업에 없음)
  "connect.person.pseudo": "사용자 #{code}",
  "connect.alert.before.title": "아직 안내문 {v}에 동의하지 않았어요",
  "connect.alert.before.desc": "동의하기 전에는 도구를 연결해도 기록을 저장하지 않아요.",
  "connect.alert.paused": "기록을 잠시 멈췄어요",
  "connect.alert.withdrawn.title": "동의를 철회해서 기록을 저장하지 않아요",
  "connect.alert.withdrawn.desc": "다시 동의하면 다음 기록부터 저장해요. 도구 연결은 그대로예요.",
  "connect.alert.resync.title": "기록 수준이 바뀌어 CLI 설정을 다시 받아야 해요",
  "connect.alert.resync.desc": "다시 받기 전까지 CLI는 예전 설정대로 보내고, 수준 밖의 값은 서버가 저장하기 전에 버려요.",
  "connect.f.noLevel": "정하지 않음",
  "connect.hist.empty": "아직 남은 연결 기록이 없어요.",
  "connect.issue.collect_token_expired": "수집 전용 토큰이 만료돼 기록을 받지 못해요",
  "connect.issue.collect_token_revoked": "수집 전용 토큰이 폐기돼 기록을 받지 못해요",
  "connect.issue.helper_not_responding": "PC 도우미가 답하지 않아요",
  "connect.issue.helper_backlog": "PC 도우미에 아직 보내지 못한 기록이 {n}건 있어요",
  "connect.issue.helper_backlog.desc": "다시 연결되면 쌓인 기록을 차례로 보내요.",
  "connect.issue.no_records": "{d}일 넘게 받은 기록이 없어요",
  "connect.issue.version_old": "CLI 버전이 지원 버전보다 낮아요",
  "connect.issue.version_checking": "새 CLI 버전이라 지원 여부를 확인하고 있어요",
  "connect.issue.version_checking.desc": "기본 정보는 저장하고 ‘지원 여부 확인 중’ 배지를 붙여요.",
  "connect.issue.generic": "연결에 문제가 생겼어요",
  "connect.over.tool_output": "도구 결과(파일 내용·명령 출력) 보내기",
  "connect.wz.token.expMax": "최대 {d}일 · 만료 {n}일 전에 알려 드려요",
  "connect.wz.token.expAt": "{date}({d}일 남음)",
  "connect.wz.test.needToken": "시험 기록을 기다리려면 먼저 ③에서 수집 전용 토큰을 받으세요.",
  "connect.wz.test.stillWaiting": "아직 첫 기록을 기다리고 있어요.",
  "connect.risk.need": "확인란을 골라야 켤 수 있어요",
  "connect.risk4.title": "작업 상세까지 기록할까요?",
  "connect.risk4.body": "명령·파일 경로·바뀐 내용이 회사 서버에 남아요. 명령이나 도구 입력에 비밀값이 섞이면 가림이 놓칠 수 있어요(가림은 정해진 형식만 찾아요).",
  "connect.risk4.check": "비밀값이 섞일 수 있다는 걸 알고 켤게요",
  "connect.risk4.ok": "④로 올리기",
  "connect.riskTool.title": "도구 결과를 켤까요?",
  "connect.riskTool.body": "파일 내용·명령 출력 일부가 회사 서버에 남아요. 비밀값·개인정보가 섞일 수 있고, 가림은 정해진 형식만 찾아요.",
  "connect.riskTool.check": "위험을 알고 켤게요",
  "connect.riskTool.ok": "켜기",
  "connect.apply.noCommand": "이 설정은 한 줄 명령으로 줄 수 없어요. 직접 붙여넣기를 고르세요.",
  "connect.apply.noLines": "붙여 넣을 줄이 없어요. 한 줄 명령을 쓰세요.",
  "connect.apply.download": "명령을 붙여 넣을 수 없으면 연결 도우미 스크립트를 내려받아 실행하세요(연결 토큰은 실행할 때 물어봐요):",
  "connect.snippet.line.codex_keep_other_otel": "# [otel]의 다른 키는 그대로 둬요",
  "connect.snippet.line.tool_output_off": "# 도구 결과(파일 내용·명령 출력)는 보내지 않아요",
  "connect.snippet.line.backup_made": "# 바꾸기 전에 원래 파일을 백업해요",
  "connect.snippet.note.codex_answers_unofficial": "Codex의 답변 글 보내기는 비공식 설정이에요(0.162.1 이상).",
  "connect.snippet.note.codex_work_detail_filtered": "Codex는 작업 상세를 늘 보내요. 서버가 기록 수준에 맞춰 걸러요.",
  "connect.snippet.note.codex_keep_other_otel": "Codex 설정 파일의 다른 기록 설정은 그대로 둬요.",
  "connect.snippet.note.metrics_untouched": "OpenAI 자체 통계에 쓰이는 설정은 바꾸지 않아요.",
  "connect.snippet.note.tool_output_off": "도구 결과(파일 내용·명령 출력)는 보내지 않게 꺼 둬요.",
  "connect.snippet.note.backup_made": "바꾸기 전에 원래 설정 파일을 백업해요.",
  "connect.app.err.nameSlug": "앱 이름은 영문 소문자·숫자·하이픈으로 2~40자를 쓰세요(예: support-summarizer).",
  "connect.app.models": "쓸 수 있는 AI 모델",
  "connect.app.modelsNone": "관리자가 이 AI 회사의 모델을 하나도 켜지 않았어요. 토큰을 만들어도 호출이 거절돼요.",
  "connect.app.modelsAuto": "모델은 고르지 않아도 돼요. 회사가 허용한 모델을 이 토큰으로 쓸 수 있고, 관리자가 바꾸면 바로 반영돼요.",
  "connect.models.q": "어떤 AI 모델을 쓸 수 있나요?",
  "connect.models.tech": "게이트웨이 허용 모델 · 사람별 사용 제한",
  "connect.models.sum": "Anthropic 모델 {a}개 · OpenAI 모델 {o}개를 쓸 수 있어요.",
  "connect.models.src": "회사 모델 설정",
  "connect.models.readOnly": "모델은 관리자가 정해요. 토큰을 만들 때 고를 필요가 없고, 아래 제한은 한 사람 기준이에요.",
  "connect.models.anyOn": "목록에 없는 모델 이름도 쓸 수 있게 허용돼 있어요.",
  "connect.models.none": "쓸 수 있는 모델이 없어요.",
  "connect.models.col.model": "모델",
  "connect.models.col.limits": "사람별 제한",
  "connect.models.col.on": "켜기",
  "connect.models.col.daily": "하루 요청 수(1인)",
  "connect.models.col.monthly": "월 토큰(1인)",
  "connect.models.dailyN": "하루 {n}회",
  "connect.models.monthlyN": "월 {n} 토큰",
  "connect.models.noLimit": "제한 없음",
  "connect.models.badge.new": "새 모델",
  "connect.models.badge.provider": "불러옴",
  "connect.models.badge.manual": "직접 추가",
  "connect.models.follow": "최신 모델 자동 추가",
  "connect.models.followD": "Hub를 업데이트해 기본 목록에 새 모델이 생기면 바로 켜져요. 직접 끈 모델은 꺼진 채로 남아요.",
  "connect.models.any": "목록에 없는 모델 이름도 허용",
  "connect.models.anyD": "켜면 아래에 없는 모델도 호출할 수 있어요. 비용을 관리하기 어려워지니 필요할 때만 켜세요.",
  "connect.models.noneOn": "{company} 모델이 하나도 켜져 있지 않아요. 이대로 저장하면 이 회사 모델 호출이 모두 거절돼요.",
  "connect.models.allOn": "모두 켜기",
  "connect.models.allOff": "모두 끄기",
  "connect.models.discover": "회사 키로 최신 모델 불러오기",
  "connect.models.bulk": "켠 모델에 같은 제한 일괄 적용",
  "connect.models.bulkApply": "켠 모델 {n}개에 적용",
  "connect.models.bulkHint": "비우면 제한 없음이에요. 하루 요청 수는 1~1,000,000회, 월 토큰은 1,000 이상이에요. 날짜와 달은 회사 시간대를 따라요.",
  "connect.models.addLabel": "모델 ID 일괄 추가",
  "connect.models.addPh": "줄마다 하나씩 또는 쉼표로 (예: claude-opus-5-5, gpt-6.1-terra)",
  "connect.models.add": "추가",
  "connect.models.added": "모델 {n}개를 추가했어요. 저장해야 적용돼요.",
  "connect.models.found": "AI 회사 목록에서 새 모델 {n}개를 불러왔어요(꺼진 상태). 쓸 모델을 켜고 저장하세요.",
  "connect.models.foundNone": "새로 불러올 모델이 없어요. 이미 모두 목록에 있어요.",
  "connect.models.remove": "목록에서 빼기",
  "connect.models.save": "모델 설정 저장",
  "connect.models.reset": "되돌리기",
  "connect.models.dirty": "저장하지 않은 변경이 있어요.",
  "connect.models.saved": "모델 설정을 저장했어요. 바로 적용돼요.",
  "connect.models.err.id": "모델 ID 형식이 맞지 않아요: {ids}",
  "connect.models.err.empty": "추가할 모델 ID를 적어 주세요.",
  "connect.models.err.many": "한 AI 회사에 모델은 200개까지 둘 수 있어요.",
  "connect.models.err.limit": "제한 값을 확인해 주세요. 하루 요청 수는 1~1,000,000회, 월 토큰은 1,000~1,000억이에요.",
  "connect.models.err.noKey": "이 AI 회사의 회사 전체용 게이트웨이 키가 없어요. 아래 회사 키 보관함에서 먼저 등록하세요.",
  "connect.models.err.keyRejected": "AI 회사가 회사 키를 거절했어요. 회사 키 보관함에서 키를 확인하세요.",
  "connect.models.err.provider": "AI 회사의 모델 목록을 받지 못했어요. 잠시 뒤 다시 시도하세요.",
  "connect.err.modelPolicy": "모델 설정을 읽지 못했어요. 관리자에게 알려 주세요.",
  "connect.keys.add": "키 등록",
  "connect.keys.addTitle": "API 키 등록",
  "connect.keys.addLead": "키 값은 받지 않아요. AI 회사 콘솔에 보이는 끝 4자리와 키 ID로 등록부에만 적어요.",
  "connect.keys.edit": "고치기",
  "connect.keys.editTitle": "{alias} 키 정보 고치기",
  "connect.keys.save": "저장",
  "connect.keys.created": "API 키를 등록부에 적었어요",
  "connect.keys.updated": "키 정보를 고쳤어요",
  "connect.keys.err": "별칭(1~40자)과 끝 4자리(4자)를 확인하세요.",
  "connect.keys.last4Hint": "키 값 전체는 넣지 마세요. 끝 4자리만 적어요.",
  "connect.keys.noOwner": "정하지 않음",
  "connect.keys.noTeam": "팀 없음",
  "connect.keys.viaGateway": "회사 게이트웨이가 쓰는 키",
  "connect.keys.inOrgReport": "조직 보고서에 나오는 키",
  "connect.cred.q": "회사 키 보관함에 어떤 키가 있나요?",
  "connect.cred.tech": "회사 키 보관함 · 봉투 암호화 · 끝 4자리만 보여요",
  "connect.cred.sum": "키 {n}개 중 {a}개를 쓰고 있어요.",
  "connect.cred.note": "게이트웨이는 사람 > 팀 > 회사 순으로 가장 구체적인 키를 골라요. 키 값은 다시 보여 주지 않아요.",
  "connect.cred.emptyWhat": "보관한 회사 키가 없어요.",
  "connect.cred.emptyNot": "회사 키가 없으면 게이트웨이가 AI를 부를 수 없어요.",
  "connect.cred.add": "회사 키 등록",
  "connect.cred.addTitle": "회사 키 등록",
  "connect.cred.addLead": "AI 회사 콘솔에서 받은 키를 붙여 넣으면 암호화해 보관하고 끝 4자리만 남겨요.",
  "connect.cred.secret": "키 값",
  "connect.cred.err": "별칭(1~40자)·키 값(8자 이상)·적용 대상을 확인하세요.",
  "connect.cred.created": "회사 키를 보관했어요",
  "connect.cred.rotated": "새 키로 바꿨어요",
  "connect.cred.rotateDesc": "새 키를 넣으면 지금 키 대신 새 키를 써요. 키 값은 다시 보여 주지 않아요.",
  "connect.cred.revoke": "폐기",
  "connect.cred.revokeTitle": "{alias} 키를 폐기할까요?",
  "connect.cred.revokeBody": "이 키를 쓰던 게이트웨이 호출은 다음 요청부터 다른 키를 고르거나 실패해요.",
  "connect.cred.revoked": "회사 키를 폐기했어요",
  "connect.cred.col.scope": "적용 대상",
  "connect.cred.col.purpose": "쓰임",
  "connect.cred.col.changed": "등록·교체",
  "connect.cred.scope.org": "회사 전체",
  "connect.cred.scope.team": "팀",
  "connect.cred.scope.user": "사람",
  "connect.cred.scopeHint": "사람 > 팀 > 회사 순으로 가장 구체적인 키를 써요.",
  "connect.cred.purpose.gateway": "게이트웨이 회사 키",
  "connect.cred.purpose.admin": "조직 보고서 키(Admin)",
  "connect.cred.src": "회사 키 보관함",
  "connect.sup.supported": "지원",
  "connect.sup.emptyWhat": "지원표를 아직 받지 못했어요.",
  "connect.sup.emptyNot": "지원하지 않는다는 뜻은 아니에요. 잠시 뒤 다시 열어 보세요.",
  "connect.cov.srcAt": "판정 기준 {date} · 지원표가 바뀌면 함께 바꿔요",
  "connect.cov.needLevel": "필요한 기록 수준",
  "connect.cov.minVersion": "최소 버전",
  "connect.attr.q": "기록 속성마다 무엇을 저장하나요?",
  "connect.attr.tech": "속성 상세 · 저장 여부(Yes/No) · 저장 위치 · 필요한 기록 수준",
  "connect.attr.sum": "속성 {n}개 중 {y}개를 저장해요.",
  "connect.attr.search": "속성 찾기",
  "connect.attr.searchPh": "속성·저장 위치 이름",
  "connect.attr.f.all": "전체",
  "connect.attr.yes": "저장(Yes)",
  "connect.attr.no": "저장 안 함(No)",
  "connect.attr.col.name": "속성",
  "connect.attr.col.stored": "저장",
  "connect.attr.col.where": "저장 위치",
  "connect.attr.col.level": "필요한 수준",
  "connect.attr.notKept": "남기지 않음",
  "connect.attr.none": "조건에 맞는 속성이 없어요",
  "connect.attr.emptyWhat": "속성 상세 표를 아직 받지 못했어요.",
  "connect.attr.emptyNot": "위의 항목 표가 무엇이 남는지 요약해 보여 줘요.",
  "connect.err.tokenLimit": "활성 연결 토큰이 이미 10개라 더 받을 수 없어요. 쓰지 않는 연결을 끊고 다시 받으세요.",
  "connect.err.invalid": "입력한 값을 다시 확인하세요.",
  "connect.err.forbidden": "이 일을 할 권한이 없어요.",
  "connect.err.notFound": "대상을 찾을 수 없어요. 화면을 새로 고쳐 보세요.",
  "connect.err.conflict": "그새 다른 곳에서 바뀌었어요. 새로 고친 뒤 다시 시도하세요.",
  "connect.err.gatewayOff": "회사 게이트웨이가 꺼져 있어요. 관리자에게 문의하세요.",
  "connect.err.gatewayConsent": "동의하지 않았거나 기록을 멈춘 상태라 회사 게이트웨이를 쓸 수 없어요.",
  "connect.err.expiry": "만료일은 90일 안에서 골라야 해요.",
  "connect.err.network": "서버에 닿지 않았어요. 연결을 확인하고 다시 시도하세요.",
  "connect.err.rule": "정해진 규칙에 맞지 않아 처리하지 못했어요.",
  "connect.err.generic": "처리하지 못했어요. 잠시 뒤 다시 시도하세요(오류 번호 {code}).",
  // 용어집(SCR-09) — 서버 계약에만 있는 칸·상태(목업에 없음)
  "glossary.e.sourceKo": "출처 이름(한국어 문서)",
  "glossary.e.sourceEn": "출처 이름(영문 문서)",
  "glossary.e.expectedKo": "기대하는 문서 제목(한국어 문서)",
  "glossary.e.expectedEn": "기대하는 문서 제목(영문 문서)",
  "glossary.e.manualRef": "사용 설명서 절",
  "glossary.e.manualRefHint": "이 시스템 용어는 외부 문서 대신 사용 설명서 절로 이어요(예: /manual/#recording).",
  "glossary.e.savedQueued": "저장했어요 · 외부 링크는 점검을 통과하면 보여요",
  "glossary.err.stale": "그새 다른 사람이 이 용어를 고쳤어요. 창을 닫고 다시 열어 주세요.",
  "glossary.err.conflict": "지금 상태에서는 할 수 없어요(라벨 사전과 이어진 용어는 숨길 수 없어요).",
  "glossary.err.invalid": "입력한 값을 다시 확인하세요.",
  "glossary.err.forbidden": "용어집을 고칠 권한이 없어요.",
  "glossary.err.notFound": "용어를 찾을 수 없어요. 화면을 새로 고쳐 보세요.",
  "glossary.err.network": "서버에 닿지 않았어요. 연결을 확인하고 다시 시도하세요.",
  "glossary.err.generic": "처리하지 못했어요. 잠시 뒤 다시 시도하세요(오류 번호 {code}).",
  "glossary.foot.checkNone": "외부 링크 점검: 주 1회 · 아직 점검 전이에요",
  "glossary.h.system": "시스템",
  "glossary.h.add": "추가",
  "glossary.hf.term": "원래 용어",
  "glossary.hf.plain": "쉬운 말",
  "glossary.hf.def": "정의",
  "glossary.hf.example": "예시",
  "glossary.hf.links": "외부 주소",
  "glossary.hf.manualRef": "사용 설명서 절",
  "glossary.lr.failed": "링크 점검을 마치지 못했어요. 잠시 뒤 다시 시도하세요.",
  "glossary.lr.never": "아직 없음",
  "glossary.lr.why.http_error": "HTTP {code} 응답이 왔어요",
  "glossary.lr.why.timeout": "제한 시간 안에 답이 오지 않았어요",
  "glossary.lr.why.title_mismatch": "문서 제목이 기대한 제목과 달라요",
  "glossary.lr.why.not_found_marker": "‘없는 문서’ 표지가 보여요",
  "glossary.lr.why.redirected": "다른 주소로 옮겨 갔어요 · 새 주소로 고쳐 주세요",
  // 실명 권한 밖의 사람(서버 PersonRef.pseudonym) — 화면 어디서나 같은 꼴
  "person.pseudo": "사용자 #{code}",
  // 알림(서버는 kind + params만 보낸다, 계획 API-17) — 매개변수가 있으면 더 자세한 꼴
  "notif.device_down.title": "도구 연결이 안 돼요",
  "notif.device_down.titleTool": "내 {tool} 연결이 안 돼요",
  "notif.device_down.titleToolDays": "내 {tool} 연결이 안 돼요 · {days}일째 기록이 없어요",
  "notif.device_down.body": "쓰지 않았다면 괜찮아요. 썼는데 기록이 없다면 연결을 확인하세요.",
  "notif.collection_unknown.title": "처음 보는 기록 항목이 있어요",
  "notif.collection_unknown.body": "새로운 기록 항목이 수신됐어요. 수집 상태에서 이름과 건수를 확인하세요.",
  "notif.collection_gap.title": "수집 공백이 있었어요",
  "notif.collection_gap.titleMin": "수집 공백 {minutes}분",
  "notif.collection_gap.body": "업무 시간에 서버 전체 수신이 30분 넘게 0건이었어요. 그 구간은 ‘서버가 받지 못한 구간’으로 표시돼요.",
  "notif.reconsent.title": "안내문에 다시 동의해 주세요",
  "notif.reconsent.titleVersion": "안내문 {version}에 다시 동의해 주세요",
  "notif.reconsent.body": "다시 동의하기 전까지 새 기록은 저장하지 않아요.",
  "notif.record_viewed.title": "내 기록이 열람됐어요",
  "notif.record_viewed.body": "누가 언제 어떤 사유로 열람했는지 ‘누가 내 기록을 봤나요’에서 볼 수 있어요.",
  "notif.record_viewed.bodyCat": "사유 범주: {reasonCategory} · ‘누가 내 기록을 봤나요’에서 자세히 볼 수 있어요.",
  "notif.token_expiring.title": "연결 토큰이 곧 만료돼요",
  "notif.token_expiring.titleDays": "연결 토큰이 {days}일 뒤 만료돼요",
  "notif.token_expiring.body": "만료 전에 도구 연결에서 새 토큰을 받으세요.",
  "notif.budget_warning.title": "예산 한도에 가까워졌어요",
  "notif.budget_warning.body": "비용 정책에서 한도와 지금까지의 추정 비용을 확인하세요.",
  "notif.version_checking.title": "지원 확인 중인 새 버전이 있어요",
  "notif.version_checking.titleVersion": "지원 확인 중인 새 버전: {tool} {version}",
  "notif.version_checking.body": "기본 정보는 저장하고, 확인이 끝날 때까지 글·작업 상세에 ‘확인 중’ 표시를 붙여요.",
  "notif.bulk_view.title": "짧은 시간에 글 열람이 많았어요",
  "notif.bulk_view.titleCount": "대량 글 열람: {minutes}분 동안 {count}건",
  "notif.bulk_view.body": "조사 건 안의 열람인지 열람·변경 이력에서 확인하세요.",
  "notif.link_broken.title": "용어집 링크를 확인해야 해요",
  "notif.link_broken.titleCount": "용어집 링크 {count}개를 확인해야 해요",
  "notif.link_broken.body": "용어집에서 점검 결과를 확인해 주세요.",
  "notif.usage_spike.title": "사용량이 평소보다 크게 늘었어요",
  "notif.usage_spike.body": "다시 돌린 배치가 있는지 통계에서 확인해 보세요.",
  "notif.team_update.title": "우리 팀 사용 현황이 바뀌었어요",
  "notif.team_update.body": "홈에서 팀원별 사용량을 이름순으로 볼 수 있어요.",
  "notif.policy_changed.title": "기록 정책이 바뀌었어요",
  "notif.policy_changed.body": "무엇이 바뀌었는지 내 기록·동의에서 볼 수 있어요.",
  "notif.deletion_processed.title": "삭제 요청을 처리했어요",
  "notif.deletion_processed.titleCount": "삭제 요청을 처리했어요 · 대화 {count}건",
  "notif.deletion_processed.body": "내 기록·동의에서 결과를 볼 수 있어요.",
  "notif.approval_pending.title": "승인을 기다리는 요청이 있어요",
  "notif.approval_pending.titleCount": "승인을 기다리는 요청이 {count}건 있어요",
  "notif.approval_pending.body": "요청한 사람과 승인하는 사람은 달라야 해요(2인 승인).",
  "notif.grant_expiring.title": "권한 부여가 곧 끝나요",
  "notif.grant_expiring.titleDays": "권한 부여가 {days}일 뒤 끝나요",
  "notif.grant_expiring.body": "계속 필요하면 관리자에게 연장을 요청하세요.",
  "notif.audit_summary.title": "이번 주 열람·변경 점검 요약이 나왔어요",
  "notif.audit_summary.titleCount": "이번 주 글 열람 {count}건",
  "notif.audit_summary.body": "열람·변경 이력에서 사유와 결과를 확인하세요.",
  // 홈(SCR-02) — 서버 계약(contracts api/home.ts)에 맞춰 목업에 더한 문구
  // 결제 방식별 사용량은 토큰 단위(계획 5.3절 FR-34, BUILD-SPEC-api API-12), 대화 수는 보조 줄
  "home.cli.authTok": "결제 방식별 사용량: 구독 로그인 {s} · API 키 {k} · 확인 안 됨 {u} 토큰",
  "home.cli.authNoteTok": "대화 수로는 구독 로그인 {s} · API 키 {k} · 확인 안 됨 {u}건",
  "home.cli.authNoteClaude": "Claude는 기기마다 마지막으로 확인한 방식이라 추정이에요",
  // 연결을 살펴볼 이유(ConnectionIssueKey)
  "home.issue.no_records": "받은 기록이 없어요",
  "home.issue.no_recordsDays": "{days}일째 기록이 없어요",
  "home.issue.helper_not_responding": "PC 도우미가 응답하지 않아요",
  "home.issue.helper_backlog": "PC 도우미가 아직 보내지 못한 기록이 쌓여 있어요",
  "home.issue.collect_token_expired": "수집 전용 토큰이 만료됐어요",
  "home.issue.collect_token_revoked": "수집 전용 토큰이 폐기됐어요",
  "home.issue.legacy_settings": "옛 설정으로 보내고 있어요. 설정을 다시 받으세요",
  "home.issue.sends_more_than_consent": "동의한 기록 수준보다 많이 보내고 있어요(넘는 값은 저장하지 않아요)",
  "home.issue.version_old": "지원 버전보다 낮은 CLI예요",
  "home.issue.version_checking": "지원 여부를 확인 중인 CLI 버전이에요",
  // 처리할 열람 일: 승인·거절 모두 사유(계획 7.4.2, API-32)
  "home.task.more": "외 {n}개",
  "home.task.aprRole": "{role} 역할의 ‘{perm}’ {from} → {to}",
  "home.task.kind.role_definition": "역할 정의를 바꾸는 요청",
  "home.task.kind.role_grant": "역할을 주는 요청",
  "home.task.kind.manager_team_content": "매니저가 팀원 글을 보게 켜는 요청",
  "home.task.kind.investigation_case": "조사 건을 시작하는 요청",
  "home.task.kind.notify_deferral": "조사 중 통지를 미루는 요청",
  "home.task.rejectTitle": "이 요청을 거절할까요?",
  "home.task.rejectBody": "거절 사유는 요청한 사람에게 보여요. 거절도 열람·변경 이력에 남아요.",
  "home.task.reasonApprove": "승인 사유",
  "home.task.reasonReject": "거절 사유(5자 이상)",
  "home.task.reasonEmpty": "승인 사유를 적어 주세요.",
  "home.task.reasonShort": "거절 사유를 5자 이상 적어 주세요.",
  "home.task.selfNo": "요청한 사람은 승인할 수 없어요(요청자 ≠ 승인자).",
  "home.task.already": "이미 처리된 요청이에요.",
  "home.task.failed": "처리하지 못했어요. 잠시 뒤 다시 시도하세요.",
  // 숫자 타일·이상 징후·수집 요약
  "home.org.costPrice": "단가표 계산 비용",
  "home.ops.stored": "오늘 저장한 기록",
  "home.anom.bulkInCase": "조사 건 안의 열람이에요 · {from}~{to}",
  "home.gapReason.server_unreachable": "서버에 닿지 못한 구간이에요",
  "home.gapReason.no_receipt": "서버 전체에 받은 기록이 없었어요",
  "home.gapReason.helper_silent": "PC 도우미가 응답하지 않았어요",
  "home.gapReason.restore": "복구 작업 중이었어요",
  "home.gapReason.maintenance": "점검 시간이었어요",
  "home.org.orgOkP": "{name} 동기화 정상",
  "home.org.orgIssue": "{name}: {issue}",
  "home.org.orgOff": "{name}: 연결 안 함",
  "home.orgIssue.late": "동기화가 늦어요",
  "home.orgIssue.auth": "관리자 키 인증이 안 돼요",
  "home.orgIssue.rate_limited": "요청 한도에 걸렸어요",
  "home.orgIssue.no_admin_key": "관리자 키가 없어요",
  "home.aud.system": "시스템",
  "logs.view.label": "목록 보기 방식",
  "logs.view.list": "대화",
  "logs.view.events": "낱개 기록",
  "logs.view.work": "파일·명령",
  "logs.ev.q": "어떤 일이 하나하나 기록됐나요?",
  "logs.ev.tech": "낱개 기록 {n}건 · 줄마다 원래 이벤트 이름",
  "logs.ev.sum": "{period} 낱개 기록은 {n}건이에요.",
  "logs.ev.col.record": "대화",
  "logs.ev.col.event": "기록",
  "logs.ev.col.detail": "내용",
  "logs.wk.q": "AI가 어떤 파일과 명령을 다뤘나요?",
  "logs.wk.tech": "파일·명령 {n}건 · 전체 경로와 명령은 내 기록이나 허가받은 기록만",
  "logs.wk.sum": "{period} 파일·명령은 {n}건이에요.",
  "logs.wk.type": "종류",
  "logs.wk.all": "모두",
  "logs.wk.file": "파일",
  "logs.wk.command": "명령",
  "logs.wk.col.type": "종류",
  "logs.wk.col.label": "이름표",
  "logs.wk.col.full": "전체 경로·명령",
  "logs.wk.col.result": "결과",
  "logs.wk.ok": "성공",
  "logs.wk.exit": "종료 코드 {n}",
  "logs.export.doneFile": "CSV 파일을 내려받았어요. 내보낸 기록도 남겼어요.",
  "logs.export.rowLimit": "한 번에 {max}건까지 내보낼 수 있어요. 조건을 좁혀 주세요.",
  "logs.export.failed": "내보내지 못했어요. 잠시 뒤 다시 해 주세요.",
  "logs.title.anonNoChars": "대화 #{no} · 질문 {n}개",
  "logs.act.viewDeniedAny": "{who} 열람 거부",
  "logs.act.export": "{who} 내보내기",
  "logs.lock.deniedNote": "거부도 열람 이력에 남아요. 사유를 다시 적어 요청할 수 있어요.",
  "logs.access.reasonLabel": "사유({n}자 이상)",
  "logs.access.tooShort": "사유를 {n}자 이상 적어 주세요. 짧은 사유로 한 요청은 거부로 남아요.",
  "logs.access.reauthDesc": "확인하면 {min}분 동안 다시 묻지 않아요.",
  "logs.access.reauthGoogle": "Google 로그인 화면에 다녀온 뒤 이 대화로 돌아와요.",
  "logs.access.reauthWrong": "비밀번호가 맞지 않아요. 다시 입력해 주세요.",
  "logs.access.noContent": "이 대화에는 열어 볼 글이 저장되어 있지 않아요.",
  "logs.access.notNeeded": "이미 볼 수 있는 대화예요. 허가 없이 열어요.",
  "logs.access.failed": "열람 허가를 받지 못했어요. 잠시 뒤 다시 해 주세요.",
  "logs.more.delete": "삭제 요청",
  "logs.more.deleteDesc": "이 대화의 글과 식별 정보를 지워 달라고 요청해요",
  "logs.delreq.title": "이 대화의 삭제를 요청할까요?",
  "logs.delreq.body": "요청하면 바로 모든 역할에서 이 대화를 볼 수 없게 막고, 7일 안에 처리해요. 법적 보관 중이면 보관이 끝난 뒤 지워요.",
  "logs.delreq.ok": "삭제 요청",
  "logs.delreq.done": "삭제를 요청했어요. 처리 결과는 알림으로 알려 드려요.",
  "logs.delreq.failed": "삭제 요청을 보내지 못했어요. 잠시 뒤 다시 해 주세요.",
  "logs.decision.accept": "허용",
  "logs.decision.reject": "거절",
  "logs.decision.abort": "중단",
  "logs.decision.timed_out": "답이 없어 시간 초과",
  "logs.err.rate_limit": "한도 초과(429)",
  "logs.err.server_error": "서버 오류(5xx)",
  "logs.err.auth": "인증 오류",
  "logs.err.client_error": "요청 오류(4xx)",
  "logs.err.network": "연결 오류",
  "logs.err.timeout": "응답 시간 초과",
  "logs.err.refusal": "정책상 거부",
  "logs.err.interrupted": "중간에 멈춤",
  "logs.err.policy_rejected": "조직 정책으로 막힘",
  "effort.max": "최대",
  "glossary.lr.manual": "내부 사용 설명서",
  "glossary.lr.why.not_checked": "자세한 점검 결과가 아직 없어요",
  "admin.hl.glossary": "용어집 링크 점검",
  "admin.hl.glossaryProgress": "{done}/{total}개 · 확인 필요 {bad}개",
  "admin.hl.glossaryDuration": "{seconds}초 걸림",
  "glossary.job.queued": "점검 대기",
  "glossary.job.running": "점검 중",
  "glossary.job.done": "점검 마침",
  "glossary.job.failed": "점검 실패",
};

export default app;
